import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website' }: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, propName?: string) => {
      let el: HTMLMetaElement | null;
      if (propName) {
        el = document.querySelector(`meta[property="${propName}"]`);
      } else {
        el = document.querySelector(`meta[name="${name}"]`);
      }
      if (el) {
        el.setAttribute('content', content);
      }
    };

    const setLink = (rel: string, href: string) => {
      let el: HTMLLinkElement | null = document.querySelector(`link[rel="${rel}"]`);
      if (el) {
        el.setAttribute('href', href);
      }
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    if (canonicalUrl) setLink('canonical', canonicalUrl);
    setMeta('og:title', title, 'og:title');
    setMeta('og:description', description, 'og:description');
    if (canonicalUrl) setMeta('og:url', canonicalUrl, 'og:url');
    setMeta('og:type', ogType, 'og:type');
    setMeta('twitter:title', title, 'twitter:title');
    setMeta('twitter:description', description, 'twitter:description');
  }, [title, description, keywords, canonicalUrl, ogType]);

  return null;
}